import { all, call } from 'redux-saga/effects';
import startAppTransaction from './StartApp.Saga';
import {
  searchImageTransaction,
  viewImageTransaction,
  searchImagesTransaction,
  searchImagesNextPageTransaction,
  autoSearchTransaction,
  fetchEvaluationInstanceTransaction,
  fetchEvaluationTransaction
} from './SearchFieldSaga';
import { infiniteScrollExperience } from './UISaga';

/* Collection of Async Transactions */
export default function* RootSaga() {
  yield all([
    call(startAppTransaction),
    call(searchImageTransaction),
    call(viewImageTransaction),
    call(searchImagesTransaction),
    call(searchImagesNextPageTransaction),
    call(autoSearchTransaction),
    call(infiniteScrollExperience),
    call(fetchEvaluationInstanceTransaction),
    call(fetchEvaluationTransaction)
  ]);
}



// WEBPACK FOOTER //
// ./src/sagas/RootSaga.js